const SHOW_FLASH_EVENT = 'show-flash';
const HIDE_FLASH_EVENT = 'hide-flash';
window.steadyFlashEventListenerInstalled = false;
function showFlash(kind, text) {
    if (!['error', 'success', 'info'].includes(kind)) {
        throw Error(`Unknown alert kind: ${kind}`);
    }
    if (window.steadyFlashEventListenerInstalled) {
        window.dispatchEvent(new CustomEvent(SHOW_FLASH_EVENT, { detail: { kind, text } }));
    }
    else {
        setTimeout(() => showFlash(kind, text), 100);
    }
}
function hideFlash(kind, text) {
    if (!['error', 'success', 'info'].includes(kind)) {
        throw Error(`Unknown alert kind: ${kind}`);
    }
    if (window.steadyFlashEventListenerInstalled) {
        window.dispatchEvent(new CustomEvent(HIDE_FLASH_EVENT, { detail: { kind, text } }));
    }
    else {
        setTimeout(() => hideFlash(kind, text), 100);
    }
}
export { SHOW_FLASH_EVENT, showFlash, HIDE_FLASH_EVENT, hideFlash };
